module.exports = __webpack_public_path__ + "img/wc.3b5967ca.png";